export class TranslatedNames {

    private internalId: string;
    public locale: string;
    public languageName: string;
    private languageImage: string;
    private supportedLanguage: string;
    public translatedValue: string;

    constructor(internalId?: string, locale?: string, languageName?: string, languageImage?: string, supportedLanguage?: string, translatedValue?: string) {
        this.internalId = internalId;
        this.locale = locale;
        this.languageName = languageName;
        this.languageImage = languageImage;
        this.supportedLanguage = supportedLanguage;
        this.translatedValue = translatedValue;
    }

    public get InternalId() {
        return this.internalId;
    }
    public get Locale() {
        return this.locale;
    }
    public get LanguageName() {
        return this.languageName;
    }
    public get LanguageImage() {
        return this.languageImage;
    }
    public get SupportedLanguage() {
        return this.supportedLanguage;
    }
    public get TranslatedValue() {
        return this.translatedValue;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set Locale(locale) {
        this.locale = locale;
    }
    public set LanguageName(languageName) {
        this.languageName = languageName;
    }
    public set LanguageImage(languageImage) {
        this.languageImage = languageImage;
    }
    public set SupportedLanguage(supportedLanguage) {
        this.supportedLanguage = supportedLanguage;
    }
    public set TranslatedValue(translatedValue) {
        this.translatedValue = translatedValue;
    }
}
